import { createAction, props } from '@ngrx/store';
import {
  RegisterForm,
  RegisterFormActions,
  RegisterFormLoadData,
  RegisterFormPay,
  RegisterReceiptData,
} from '../models/register.model';

export const init = createAction(RegisterFormActions.REGISTER_FORM_INIT);

export const loadForm = createAction(
  RegisterFormActions.LOAD_REGISTER_FORM,
  props<{ data: RegisterFormLoadData }>()
);

export const loadFormSuccess = createAction(
  RegisterFormActions.LOAD_REGISTER_FORM_SUCCESS,
  props<{ data: RegisterFormLoadData }>()
);

export const validateForm = createAction(
  RegisterFormActions.VALIDATE_FORM,
  props<{ data: RegisterForm }>()
);

export const validateFormSuccess = createAction(
  RegisterFormActions.VALIDATE_FORM_SUCCESS,
  props<{ data: RegisterFormLoadData }>()
);

export const validateFormError = createAction(
  RegisterFormActions.VALIDATE_FORM_ERROR,
  props<{ error: any }>()
);

export const pay = createAction(
  RegisterFormActions.PAY,
  props<{ userData: RegisterForm; data: RegisterFormPay }>()
);

export const paySuccess = createAction(
  RegisterFormActions.PAY_SUCCESS,
  props<{ paymentData: RegisterReceiptData }>()
);

export const payError = createAction(
  RegisterFormActions.PAY_ERROR,
  props<{ error: any }>()
);

export const confirm = createAction(
  RegisterFormActions.CONFIRM,
  props<{ token: string }>()
);

export const confirmSuccess = createAction(RegisterFormActions.CONFIRM_SUCCESS);

export const confirmError = createAction(
  RegisterFormActions.CONFIRM_ERROR,
  props<{ error: any }>()
);
